import { Typography } from '@mui/material';

export default Typography;
